export function checkTokenRequest(token) {
  return {
    type: '@resetpassword/CHECK_TOKEN_REQUEST',
    payload: { token },
  };
}

export function checkTokenSuccess(token) {
  return {
    type: '@resetpassword/CHECK_TOKEN_SUCCESS',
    payload: { token },
  };
}

export function checkTokenFailure(error) {
  return {
    type: '@resetpassword/CHECK_TOKEN_FAILURE',
    payload: { error },
  };
}

export function sendEmailRequest(email) {
  return {
    type: '@resetpassword/SENDEMAIL_REQUEST',
    payload: { email },
  };
}

export function sendEmailSuccess(success) {
  return {
    type: '@resetpassword/SENDEMAIL_SUCCESS',
    payload: { success },
  };
}

export function resetPasswordRequest(senha, confirma, token) {
  return {
    type: '@resetpassword/RESETPASSWORD_REQUEST',
    payload: { senha, confirma, token },
  };
}
